import { ReactComponent as Logo } from '@assets/images/logo.svg';
import { ReactComponent as LogoMinimized } from '@assets/images/logo-minimized.svg';
import { cn } from 'component-library/utils';
import React, { SVGProps } from 'react';

type LandlerLogoProps = SVGProps<SVGSVGElement> & {
  color?: 'primary' | 'white';
  isCollapsed?: boolean;
};

export const LandlerLogo: React.FC<LandlerLogoProps> = ({
  color = 'primary',
  className,
  isCollapsed = false,
  ...delegated
}) => {
  const styles = cn(
    {
      'text-primary-100': color === 'primary',
      'text-white-100': color === 'white',
    },
    className,
  );

  return isCollapsed ? (
    <LogoMinimized className={styles} data-testid='landler-logo-collapsed' {...delegated} />
  ) : (
    <Logo className={styles} data-testid='landler-logo' {...delegated} />
  );
};
